import { AxiosInstance } from 'axios';
import { Items } from 'store/menu/types';

export const suggestions = (ApiClient: () => Promise<AxiosInstance>) => {
  return {
    changeSuggestions: async (id: string, body: string[]) =>
      (await ApiClient()).put<Items>(`/suggestion/${id}`, body),
  };
};
